import React from 'react'
import PropTypes from 'prop-types'

import s from './Overlay.scss'


const Overlay = ({ children, onClick }) => (
  <div className={s.overlay} onClick={onClick}>
    {children}
  </div>
)

Overlay.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
}


export default Overlay
